import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSearchDataModeActive } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

replaceInChain(chain, PopulateApiParameter,  props => {
    props.apiParameter = {
        ...props.parameter,
        expand: ["detail", "specifications", "content", "images", "documents", "attributes", "variantTraits", "badges", "properties"],
        includeAttributes: ["includeOnProduct"],
    };
})